import { render, staticRenderFns } from "./home_hot.vue?vue&type=template&id=6c893c1a&scoped=true&"
import script from "./home_hot.vue?vue&type=script&lang=js&"
export * from "./home_hot.vue?vue&type=script&lang=js&"
import style0 from "./home_hot.vue?vue&type=style&index=0&id=6c893c1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c893c1a",
  null
  
)

export default component.exports